
<template>
    <div class="tab-pane" :class="'show active'" :id="`tab-${index}-pane`" role="tabpanel" tabindex="0">

        <!-- Heading -->
        <div class="d-flex justify-content-between align-items-center">
            <h2 class="fw-bold text-start m-0">{{ title }}</h2>
            <!-- Add new question button -->
            <template v-for="(button, index) in props.buttons">
                <button type="button" class="btn" :class="button.class" @click="button.callback" v-ripple>
                    {{ button.title }}
                </button>
            </template>
        </div>

        <slot :name="'content'" v-bind="{ title }"></slot>
    </div>

</template>

<script setup>
const props = defineProps({
    title: String,
    index: Number,
    buttons: Array
});
</script>

<style lang="scss" scoped></style>